export default class EmergencyCenter {

  id = null;

  name = '';
  street = '';
  zip = '';
  city = '';
  country = ''

  contactName = '';
  contactMail = '';
  contactPhone = '';

  mailSubject = '';
  mailContent = '';

  constructor() {
  }
}
